import * as React from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <Wrapper
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        display: value === index ? "flex" : "block",
        flexDirection: "column",
        flexGrow: value === index ? 1 : 0
      }}
      {...other}
    >
      {value === index && (
        <Stack sx={{ py: "8px", flexGrow: 1 }}>
          {children}
        </Stack>
      )}
    </Wrapper>
  )
}

const Wrapper = styled("div")(({ theme }) => ({
  padding: "0 16px"
}))
